module.exports.default = {
    "ORDER": "Παραγγελία",
    "SCHEDULE.YOU_ARE_ALL_SET": "Είστε έτοιμοι",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Το ραντεβού σας είναι προγραμματισμένο για",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Γεια #. Προγραμματίστε το ραντεβού σας:",
    "SCHEDULE.SCHEDULE_NOW": "Πρόγραμμα",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Ενημερώσεις Παραγγελίας",
    "SCHEDULE.EMAIL_UPDATES": "Ενημερώσεις μέσω E-Mail",
    "SCHEDULE.SMS_UPDATES": "Ενημερώσεις μέσω SMS",
    "SCHEDULE.DISABLE_UPDATES": "Δεν θέλω να λαμβάνω ενημερώσεις",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Θα ήθελα να λαμβάνω ενημερώσεις κατάστασης για την παράδοσή μου στα ακόλουθα κανάλια:",
    "OOPS": "Ωχ!",
    "SOMETHING_WENT_WRONG": "Υπάρχει κάποιο λάθος στην εντολή σας",
    "REFRESH": "Ανανέωση",
    "PAGE_NOT_FOUND": "Η σελίδα δεν βρέθηκε",
    "COULD_NOT_FIND_PAGE": "Δεν μπορέσαμε να βρούμε τη σελίδα που ψάχνατε.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Δεν είναι δυνατή η αποστολή κενού μηνύματος",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Παρακαλούμε πληκτρολογήστε το μήνυμά σας προς τον οδηγό",
    "TRACKING.SEND": "Αποστολή μέσω messenger",
    "TRACKING.ARRIVING_AT": "Άφιξη σε",
    "TRACKING.ETA": "ETA",
    "TRACKING.MIN": "λεπτά",
    "TRACKING.MAP": "Οδική Κίνηση",
    "TRACKING.SATELLITE": "Δορυφόρος",
    "TRACKING.TERRAIN": "Ανάγλυφο Εδάφους",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Γεια, έχω φτάσει!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "έχει φτάσει στο",
    "COMPLETED": "Η παραγγελία έχει προγραμματιστεί",
    "RATING.SKIP": "Όχι Τώρα",
    "RATING.WHAT_WENT_WELL": "Τι πήγε καλά;",
    "RATING.WHAT_WENT_WRONG": "Τι πήγε στραβά;",
    "RATING.THANK_YOU": "Σας ευχαριστούμε",
    "RATING.FOR_USING_OUR_SERVICE": "Ευχαριστούμε που χρησιμοποιήσατε την υπηρεσία μας!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Πώς ήταν η εμπειρία παράδοσής σας;",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Παρακαλούμε βοηθήστε μας να βελτιωθούμε, βαθμολογώντας την εμπειρία σας",
    "SCHEDULE.RATE_US": "Βαθμολογήστε Μας!",
    "TERM_OF_USE": "Όροι Χρήσης Υπηρεσίας",
    "PRIVACY_POLICY": "Πολιτική Προστασίας Προσωπικών Δεδομένων",
    "SHARING_MY_LOCATION": "Βρες Με",
    "SHARING_LOADING": "Γίνεται φόρτωση",
    "REQUIRED_FIELD_MESSAGE": "Απαιτούνται όλα τα πεδία",
    "CONTACT_NAME": "Όνομα Επαφής",
    "PHONE_NUMBER": "Τηλεφωνικός Αριθμός",
    "EMAIL_ADDRESS": "Διεύθυνση E-Mail",
    "SEND": "Αποστολή",
    "FORWARD.THIS_ORDER": "Προώθηση αυτής της παράδοσης",
    "FORWARD.TO_CONTACT": "Προώθηση σε επαφή στο",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Είστε σίγουρος ότι θέλετε να προωθήσετε αυτή την παράδοση;",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "σας προώθησε μια παράδοση",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Είστε σίγουρος ότι θέλετε να απορρίψετε αυτή την παράδοση;",
    "ACCEPT": "Αποδοχή",
    "REJECT": "Απόρριψη",
    "PICKUP.SET_PICKUP_TIME": "Είμαι καθ' οδόν",
    "PICKUP.IVE_ARRIVED": "Έφτασα",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Ωχ, κάτι πήγε στραβά.\n",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Δοκιμάστε ξανά.",
    "PICKUP.MIN": "λεπτά",
    "PICKUP.SHOW_THIS_NUMBER": "Δείξτε αυτόν τον αριθμό στον υπάλληλο για να παραλάβετε την παραγγελία σας",
    "PICKUP.IM_OUTSIDE": "Είμαι εδώ",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Ενημερώστε μας όταν είστε εδώ.",
    "PICKUP.I_WILL_ARRIVE_AT": "Θα φτάσω στις",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "Η ώρα παραλαβής ορίστηκε με επιτυχία",
    "PICKUP.IN": "Σε",
    "PICKUP.TO": "Προς",
    "PICKUP.COLLECT": "Παραγγελία Συλλέχθηκε",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "Επιλέξτε Μέθοδο Μεταφοράς",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "Επιβεβαίωση μεθόδου μεταφοράς",
    "PICKUP.CANCEL": "Ακύρωση",
    "PICKUP.CONFIRM_TIME": "Επιβεβαίωση ώρας άφιξης παραλαβής",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "Ο οδηγός είναι επί του παρόντος μία στάση μακριά από εσάς",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "στάσεις μακριά από εσάς",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "Ο οδηγός είναι αυτή τη στιγμή",
    "PICKUP.OK": "OK",
    "PICKUP.NEXT": "Επόμενο",
    "PICKUP.SKIP": "Παράλειψη",
    "CAR_ARRIVED.TITLE": "Τελευταίο βήμα! Ενημερώστε μας πώς να σας βρούμε:",
    "CAR_ARRIVED.PARKING_SPOT": "Χώρος στάθμευσης / Αριθμός θέσης",
    "CAR_ARRIVED.LICENSE_PLATE": "Αριθμός πινακίδας κυκλοφορίας",
    "CAR_ARRIVED.VEHICLE_MODEL": "Μοντέλο και Μάρκα Οχήματος",
    "CAR_ARRIVED.VEHICLE_COLOR": "Χρώμα οχήματος",
    "CAR_ARRIVED.REMEMBER": "Θυμηθείτε τα στοιχεία του οχήματός μου",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Παράδειγμα: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Παράδειγμα: 195-QUD)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Παράδειγμα: Ford Bronco)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Παράδειγμα: Μπλε)",
    "REDIRECT_PICKUP.TO": "Προς",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "Αλλαγή τοποθεσίας παραλαβής;",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "Η τοποθεσία παραλαβής άλλαξε με επιτυχία",
    "REDIRECT_PICKUP.FAILED_TITLE": "Δεν ήταν δυνατή η αλλαγή της τοποθεσίας παραλαβής",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Κάτι πήγε στραβά",
    "REDIRECT_PICKUP.OK": "OK",
    "REDIRECT_PICKUP.KM": "χλμ",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Επιλογή τοποθεσίας παραλαβής",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Ορισμός ως τοποθεσία παραλαβής",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Επιλογές παραλαβής",
    "SOON": "Σύντομα",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "Θέλετε να καλέσετε τον οδηγό παράδοσής σας;",
    "GLOBAL.CALL": "Κλήση",
    "GLOBAL.CANCEL": "Ακύρωση",
    "﻿PICKUP.SET_PICKUP_TIME": "Είμαι καθ' οδόν",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Η παραγγελία σας σας περιμένει ακριβώς έξω από την πόρτα σας!",
    "SCHEDULED.THANKS_FOR_USING": "Ευχαριστούμε που χρησιμοποιήσατε {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "Η αποστολή σας {{external_id}} είναι σε διαμετακόμιση",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Η παραγγελία σας είναι προγραμματισμένη για",
    "Submit": "Υποβολή",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Για να βαθμολογήσετε, επιλέξτε πρώτα τα αστέρια",
    "PICKUP.SHOW_ID": "Εμφάνιση ταυτότητας",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "Εκτιμώμενος χρόνος άφιξης",
    "OPEN_MENU": "Άνοιγμα μενού",
    "CLOSE_MENU": "Κλείσιμο μενού",
    "MAP_AUTO_CENTER": "Αυτόματη εστίαση χάρτη",
    "MAP_SETTINGS": "Ρυθμίσεις χάρτη",
    "ZOOM_OUT": "Σμίκρυνση",
    "ZOOM_IN": "Μεγέθυνση",
    "TRACKING.CALL_DRIVER": "Κλήση οδηγού",
    "TRACKING.MESSAGE_DRIVER": "Μήνυμα στον οδηγό",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "Επιβεβαίωση ώρας άφιξης παραλαβής",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "Δεν θέλουμε να περιμένετε.\nΕνημερώστε μας όταν είστε καθ' οδόν ή φτάνετε:",
    "SCHEDULE.TIME_ZONE_TEXT": "Ζώνη ώρας",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "Εργαζόμαστε πάνω σε αυτό!",
    "TRACKING.THANKS_MESSAGE_TEXT": "Συλλέγουμε τα είδη σας και ένα μέλος της ομάδας θα είναι σύντομα έξω στο αυτοκίνητό σας",
    "TRACKING.THANKS_MESSAGE_TITLE": "Ευχαριστούμε για τον έλεγχο",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "Παρακαλώ πηγαίνετε στο σημείο συλλογής στο κατάστημα όπου η παραγγελία σας είναι έτοιμη για παραλαβή",
    "CANCEL_ORDER": "Ακύρωση παραγγελίας",
    "CANCELLATION_VALIDATION_TITLE": "Είστε βέβαιοι ότι θέλετε να ακυρώσετε αυτήν την παραγγελία;",
    "CANCELLATION_VALIDATION_BACK": "Πίσω",
    "CANCELLATION_VALIDATION_YES": "Ναι, παρακαλώ",
    "CANCEL_SUCCESS": "Ακυρώσαμε την παραγγελία σας",
    "CANCEL_PAST_ALLOWED": "Η ακύρωση της παραγγελίας έληξε",
    "CANCEL_ERROR": "Δεν μπορέσαμε να ακυρώσουμε την παραγγελία σας",
    "RATING.FREE_TEXT_COMMENT": "Πείτε μας περισσότερα",
    "RATING.ORDER_DELIVERED_GREEN": "Παραδώσαμε την παραγγελία σας με ένα φιλικό προς το περιβάλλον όχημα",
    "CX_ORDER_STATUS.CONFIRMED": "Παραγγελία επιβεβαιώθηκε. Είμαστε σε αυτό.",
    "CX_ORDER_STATUS.RECEIVED": "Παραγγελία ελήφθη. Θα επικοινωνήσουμε μαζί σας σύντομα.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Βρίσκουμε έναν οδηγό για την παραγγελία σας.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Βρήκαμε τον οδηγό για την παραγγελία σας.",
    "CX_ORDER_STATUS.PICKING_UP": "Συλλέγουμε την παραγγελία σας τώρα.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Είμαστε καθ' οδόν για να παραλάβουμε την παραγγελία σας.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Ολοκληρώνουμε μια προηγούμενη παράδοση πριν από την παραγγελία σας.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "Η παραγγελία σας είναι τώρα καθ' οδόν!",
    "CX_ORDER_STATUS.ARRIVED": "Η παραγγελία σας έφτασε!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Κατάσταση παράδοσης",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Εμφάνιση κατάστασης παράδοσης στους πελάτες",
    "CONFIRM": "Επιβεβαίωση",
    "FLOW_OPTIONS.TITLE": "Πώς θέλετε να παραλάβετε την παραγγελία σας;",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Παραδόθηκε στο αυτοκίνητό σας σε καθορισμένο σημείο",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Παραλαβή από το πεζοδρόμιο",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Παραλαβή στο κατάστημα ή σε καθορισμένη τοποθεσία",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Κάντε κλικ και συλλέξτε",
    "RATING_STAR_ALT": "Επιλέξτε έως και 5 αστέρια για να υποβάλετε μια βαθμολογία",
    "RATING_STAR_ALT_ONE": "Επιλέξτε για υποβολή",
    "RATING_STAR_ALT_TWO": "βαθμολογία αστέρων",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "Ο εκτιμώμενος χρόνος άφιξης είναι",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Χάρτης για την παρακολούθηση της παραγγελίας",
    "SCHEDULE.EXTERNAL_ID_INFO": "Αριθμός παραγγελίας: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "Σχόλιο",
    "SCHEDULE.CANCEL_NOTE_INPUT": "Διαγραφή",
    "DELIVERY_WAS_CANCELLED": "Η παράδοση ακυρώθηκε",
    "QUESTIONNAIRE.SKIP": "Παράλειψη",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "Είστε βέβαιοι ότι θέλετε να παραλείψετε;",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "Δεν έχουν απαντηθεί ορισμένες ερωτήσεις. Είστε βέβαιοι ότι θέλετε να συνεχίσετε χωρίς να τις συμπληρώσετε;",
    "QUESTIONNAIRE.BACK": "Πίσω",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": ""
};
	